const launcher = document.querySelector("[data-intercom-launcher]");

if (launcher) {
  const initializeIntercomLauncher = () => {
    if (typeof window.Intercom !== "function") {
      return false;
    }

    window.Intercom("update", {
      hide_default_launcher: true,
    });

    launcher.classList.add("custom-intercom-launcher--ready");

    return true;
  };

  function syncIntercomLauncher(attempt = 0) {
    if (initializeIntercomLauncher()) {
      return;
    }

    if (attempt >= 60) {
      return;
    }

    setTimeout(() => syncIntercomLauncher(attempt + 1), 1000);
  }

  launcher.addEventListener("click", () => {
    if (typeof window.Intercom === "function") {
      window.Intercom("show");
    }
  });

  if (document.readyState === "complete") {
    syncIntercomLauncher();
  } else {
    window.addEventListener("load", () => syncIntercomLauncher(), {
      once: true,
    });
  }

  let stickyBars = [];
  let stickyBarResizeObserver = null;
  let stickyBarClassObserver = null;

  const updateLauncherPosition = () => {
    const visibleMobileStickyBar = stickyBars.find(
      (bar) =>
        bar.classList.contains("sticky-atc-custom--mobile") &&
        bar.classList.contains("sticky-atc-custom--visible") &&
        bar.getBoundingClientRect().height > 0,
    );

    const shouldMoveAboveSticky = Boolean(visibleMobileStickyBar);

    const barHeight = visibleMobileStickyBar
      ? visibleMobileStickyBar.getBoundingClientRect().height
      : 0;

    launcher.style.setProperty("--sticky-atc-height", `${barHeight}px`);

    launcher.classList.toggle(
      "custom-intercom-launcher--above-sticky",
      shouldMoveAboveSticky,
    );
  };

  const bindStickyBars = () => {
    const newStickyBars = [...document.querySelectorAll(".sticky-atc-custom")];

    if (!newStickyBars.length) {
      return;
    }

    stickyBarResizeObserver?.disconnect();
    stickyBarClassObserver?.disconnect();

    stickyBars = newStickyBars;

    if ("ResizeObserver" in window) {
      stickyBarResizeObserver = new ResizeObserver(updateLauncherPosition);

      stickyBars.forEach((bar) => {
        stickyBarResizeObserver.observe(bar);
      });
    }

    stickyBarClassObserver = new MutationObserver(updateLauncherPosition);

    stickyBars.forEach((bar) => {
      stickyBarClassObserver.observe(bar, {
        attributes: true,
        attributeFilter: ["class"],
      });
    });

    updateLauncherPosition();
  };

  if (!("ResizeObserver" in window)) {
    window.addEventListener("resize", updateLauncherPosition);
  }

  bindStickyBars();
}
